import { AUTH, type ApiResponse, type LoginPayload, type LoginResult, type SendCodePayload } from '@luogen/shared';
import { http } from './http';

export async function sendCode(payload: SendCodePayload): Promise<ApiResponse<null>> {
  const { data } = await http.post<ApiResponse<null>>(AUTH.sendCode, payload);
  return data;
}

export async function login(payload: LoginPayload): Promise<ApiResponse<LoginResult>> {
  const { data } = await http.post<ApiResponse<LoginResult>>(AUTH.login, payload);
  return data;
}

export async function logout(account: string): Promise<ApiResponse<null>> {
  const { data } = await http.post<ApiResponse<null>>(AUTH.logout, { account });
  return data;
}
